import { render, staticRenderFns } from "./RegistrationValidation.vue?vue&type=template&id=d89f0e00&"
import script from "./RegistrationValidation.vue?vue&type=script&lang=js&"
export * from "./RegistrationValidation.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationValidation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports